import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["selected"]
  declare readonly selectedClass: string

  static targets = ["countInput", "decrementButton", "incrementButton"]
  declare readonly countInputTarget: HTMLInputElement
  declare readonly decrementButtonTarget: HTMLButtonElement
  declare readonly incrementButtonTarget: HTMLButtonElement

  static values = {
    count: Number,
    max: Number,
    min: Number,
    step: Number
  }
  declare countValue: number
  declare readonly maxValue: number
  declare readonly minValue: number
  declare readonly stepValue: number

  countValueChanged(): void {
    this.countInputTarget.value = this.countValue.toString()
    this.decrementButtonTarget.disabled = this.countValue - this.stepValue < this.minValue
    this.incrementButtonTarget.disabled = this.countValue + this.stepValue > this.maxValue

    this.element.classList.toggle(this.selectedClass, this.countValue > 0)
    this.dispatch("countChanged", { detail: { count: this.countValue, max: this.maxValue } })
  }

  decrement(): void {
    this.countValue = Math.max(this.minValue, this.countValue - this.stepValue)
  }

  increment(): void {
    this.countValue = Math.min(this.maxValue, this.countValue + this.stepValue)
  }
}
